<div class="workspace-switcher-card">
    <!-- User Profile Section -->
    <div class="profile-section">
        <div class="profile-content">
            <div class="profile-avatar">{{ userInitials }}</div>
            <div class="profile-info">
                <h4 class="profile-name">{{ userName }}</h4>
                <p class="profile-role">{{ getCurrentRoleDisplayName() }}</p>
            </div>
        </div>
    </div>

    <!-- Divider -->
    <div class="divider"></div>

    <!-- Switch Workspace Section -->
    <div class="workspace-section">
        <h5 class="section-title">SWITCH WORKSPACE</h5>
        <p class="switching-status">{{ getSwitchingStatusMessage() }}</p>
        
        <div class="roles-container">
            <!-- Available and Unavailable Roles -->
            <div *ngFor="let role of allRoles" class="role-card" [ngClass]="{ 'active': isCurrentWorkspace(role), 'disabled': !isRoleAvailable(role) }">
                <div class="role-content" (click)="handleRoleClick(role)">
                    <div class="role-selection">
                        <input 
                            type="radio" 
                            [id]="'role-' + role"
                            [name]="'workspace'"
                            [value]="role"
                            [checked]="isCurrentWorkspace(role)"
                            [disabled]="!isRoleAvailable(role) || !isSwitchingEnabled()"
                            (change)="switchWorkspace(role)"
                            class="role-radio"
                        />
                        <label [for]="'role-' + role" class="role-label">
                            <span class="role-name">{{ getRoleDisplayName(role) }}</span>
                        </label>
                    </div>
                    
                    <!-- Status Badge -->
                    <div class="role-badge" *ngIf="isCurrentWorkspace(role)">
                        <span class="badge-checkmark">✓</span>
                        <span class="badge-text">Active</span>
                    </div>
                    <div class="role-badge locked" *ngIf="!isRoleAvailable(role)">
                        <span class="badge-icon">🔒</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Divider -->
    <div class="divider"></div>

    <!-- Status Section -->
    <div class="status-section">
        <h5 class="section-title">STATUS</h5>
        <p class="status-text">{{ statusText }}</p>
    </div>

    <!-- Sign Out Button -->
    <div class="divider"></div>
    <div class="action-section">
        <button class="sign-out-button" (click)="handleSignOut()">Sign out</button>
    </div>
</div>

<!-- Access Denied Toast (appears when trying unauthorized role) -->
<div *ngIf="showAccessDeniedModal" class="access-denied-toast">
    <div class="toast-content">
        <span class="toast-icon">⚠️</span>
        <div class="toast-text">
            <p class="toast-title">Access Denied</p>
            <p class="toast-message">You don't have access to this workspace.</p>
        </div>
    </div>
    <button class="toast-close" (click)="closeAccessDeniedModal()">✕</button>
</div>
